import { formatTimeDurationMs } from '../../utils/timeUtils';
import {
  DURATION_UPPER_LIMIT_MS,
  P50_LATENCY_OBJECTIVE_MS,
  P50_LATENCY_WARNING_MS,
  P50_LATENCY_CRITICAL_MS,
  P95_LATENCY_OBJECTIVE_MS,
  P95_LATENCY_WARNING_MS,
  P95_LATENCY_CRITICAL_MS,
  P99_LATENCY_OBJECTIVE_MS,
  P99_LATENCY_WARNING_MS,
  P99_LATENCY_CRITICAL_MS,
} from '../../utils/constants';

const LATENCY_TIERS = [
  ['Average',        'p50', P50_LATENCY_OBJECTIVE_MS, P50_LATENCY_WARNING_MS, P50_LATENCY_CRITICAL_MS],
  ['95th Percentile','p95', P95_LATENCY_OBJECTIVE_MS, P95_LATENCY_WARNING_MS, P95_LATENCY_CRITICAL_MS],
  ['99th Percentile','p99', P99_LATENCY_OBJECTIVE_MS, P99_LATENCY_WARNING_MS, P99_LATENCY_CRITICAL_MS],
];

const LatencyStatsDisplay = ({ latencyStats = {} }) => (
  <div className="d-flex gap-2 flex-wrap">
    {LATENCY_TIERS.map(([label, key, objMs, warnMs, critMs]) => {
      const val = latencyStats[key] ?? null;
      let description;
      let bgClass;
      let textClass;
      switch (true) {
        case val === null:
          description = 'No data';
          bgClass = 'secondary';
          textClass = 'text-white';
          break;
        case val < objMs:
          description = 'Great';
          bgClass = 'success';
          textClass = 'text-white';
          break;
        case val < warnMs:
          description = 'Good';
          bgClass = 'success';
          textClass = 'text-white';
          break;
        case val < critMs:
          description = 'Fair';
          bgClass = 'warning';
          textClass = 'text-dark';
          break;
        default:
          description = 'Poor';
          bgClass = 'danger';
          textClass = 'text-white';
      }
      return (
        <div
          key={key}
          title={`${label}: ${description}`}
          className={`bg-${bgClass}-subtle d-inline-flex align-items-center gap-1 border border-${bgClass} rounded-3 pe-2 shadow-sm`}
          style={{ fontSize: '0.78rem', cursor: 'default', width: '6rem', justifyContent: 'space-between' }}
        >
          <span className={`bg-${bgClass} ${textClass} rounded-start px-2 py-1`} style={{ fontSize: '0.72rem' }}>{key}</span>
          <span className={`text-${bgClass}-emphasis`} >{val != null ? formatTimeDurationMs(val, DURATION_UPPER_LIMIT_MS) : '0'}</span>
        </div>
      );
    })}
  </div>
);

export default LatencyStatsDisplay;
